var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.39 18.75a.63.63 0 0 1-.366-.118L10 14.99l-5.024 3.642a.625.625 0 0 1-.959-.706l1.96-5.803L.899 8.64A.625.625 0 0 1 1.25 7.5h6.265l1.89-5.819a.625.625 0 0 1 1.19 0l1.89 5.82h6.265a.624.624 0 0 1 .354 1.141l-5.08 3.48 1.958 5.802a.624.624 0 0 1-.591.826"
  })));
};
export { SvgStar as ReactComponent };